﻿
<div class="form-element subtitle-section my-15 fs-14">
  {{ referenceDataLabels.AboutTheMortgageDetails | localizeLabel }}
</div>
<!--TODO: check if this container is still needed after fixing loading data with the resolver-->
<ng-container *ngIf="mortgageApplication && applicationProducts">
  <!--168-->
  <ng-container *ngIf="mortgageApplication.isPurchase">
    <div class="d-flex align-items-center flex-column flex-md-row">
      <boi-form-numeric-input
        [isFieldDisabled]="
          mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly || isAmendButtonAvailable
        "
        [labelName]="referenceDataLabels.WhatIsTheorPriceOfTheProId"
        [isCurrency]="true"
        [(value)]="mortgageApplication.PurchasePropertyPrice"
        [propertyNames]="['PurchasePropertyPrice']"
        (valueChange)="onDprRelatedFieldValueChanged()"
        [fieldMaxLength]="7"
      ></boi-form-numeric-input>

      <ng-container *ngIf="isAmendButtonAvailable">
        <button
          (click)="onAmendClick()"
          [innerHtml]="referenceDataLabels.ProductPickerAmend | localizeLabel"
          class="vo-secondary-button-1 full-width-md-button"
        ></button>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.DateCIDDIssued">
    <!--295-->
    <boi-form-date
      [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly || areNichaFieldsDisabled"
      [labelName]="referenceDataLabels.DateCIDDIssued"
      [(value)]="mortgageApplication.DateCIDDIssued"
      [propertyNames]="['DateCIDDIssued']"
    ></boi-form-date>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.IsNICHAApplication">
    <!--296-->
    <boi-form-radio-button
      [optionList]="referenceDataOptionLists.AnswerType"
      [isFieldDisabled]="
        mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly || areNichaFieldsDisabled
      "
      [labelName]="referenceDataLabels.IsNICHAApplication"
      [(value)]="mortgageApplication.IsNICHAApplication"
      [propertyNames]="['IsNICHAApplication']"
    ></boi-form-radio-button>
  </ng-container>

  <!--297-->
  <ng-container *ngIf="isProductForNICHA()">
    <boi-form-date
      [isFieldDisabled]="
        mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly || areNichaFieldsDisabled
      "
      [labelName]="referenceDataLabels.DateNICHALetterReceived"
      [(value)]="mortgageApplication.DateNICHALetterReceived"
      [propertyNames]="['DateNICHALetterReceived']"
    >
    </boi-form-date>
    <!--7.2-->
    <boi-form-numeric-input
      [labelName]="referenceDataLabels.PropertySharePercentage"
      [fieldMaxLength]="2"
      [isFieldDisabled]="
        mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly || areNichaFieldsDisabled
      "
      [(value)]="mortgageApplication.PropertySharePercentage"
      [propertyNames]="['PropertySharePercentage']"
    >
    </boi-form-numeric-input>

    <!--7.3-->
    <boi-form-numeric-input
      [labelName]="referenceDataLabels.MonthlyRentalForNotPurchasedProperty"
      [fieldMaxLength]="4"
      [(value)]="mortgageApplication.MonthlyRentalForNotPurchasedProperty"
      [isFieldDisabled]="
        mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly || areNichaFieldsDisabled
      "
      [propertyNames]="['MonthlyRentalForNotPurchasedProperty']"
    ></boi-form-numeric-input>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.isPurchase">
    <!--168.1-->
    <boi-form-radio-button
      [optionList]="referenceDataOptionLists.AnswerType"
      [labelName]="referenceDataLabels.AreYouPurchasingAtAConcessionaId"
      [(value)]="mortgageApplication.PurchasingAtConcessionaryPriceCode"
      [isFieldDisabled]="
        mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly || isAmendButtonAvailable
      "
      [propertyNames]="['PurchasingAtConcessionaryPriceCode']"
      [contextualHelpName]="['AppPurchaseConcessionary']"
    >
    </boi-form-radio-button>

    <ng-container
      *ngIf="mortgageApplication.PurchasingAtConcessionaryPriceCode === referenceDataOptionLists.AnswerTypeYes"
    >
      <!--168.2-->
      <boi-form-numeric-input
        [labelName]="referenceDataLabels.WhatIsTheTrueMarketValueOfThePId"
        [isCurrency]="true"
        [fieldMaxLength]="7"
        [fieldMinValue]="25000"
        [(value)]="mortgageApplication.TrueMarketPrice"
        [isFieldDisabled]="
          mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly || isAmendButtonAvailable
        "
        [propertyNames]="['TrueMarketPrice']"
        (valueChange)="onDprRelatedFieldValueChanged()"
      ></boi-form-numeric-input>

      <!--168.3-->
      <boi-form-text-input
        *ngIf="!mortgageApplication.IsFactFind"
        [fieldMaxLength]="1500"
        [labelName]="referenceDataLabels.ConcessionNature"
        [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
        [(value)]="mortgageApplication.ConcessionNature"
        [propertyNames]="['ConcessionNature']"
      ></boi-form-text-input>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.isRemortgage">
    <div class="d-flex align-items-center flex-column flex-md-row">
      <!--170-->
      <boi-form-numeric-input
        [labelName]="referenceDataLabels.WhatIsTheEstimatedValueOfProp"
        [isCurrency]="true"
        [isFieldDisabled]="
          mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly || isAmendButtonAvailable
        "
        [(value)]="mortgageApplication.RemortgageEstimatedPropertyValue"
        [fieldMaxLength]="7"
        [propertyNames]="['RemortgageEstimatedPropertyValue']"
        [contextualHelpName]="
          mortgageApplication.isBuyToLet
            ? referenceDataContextualHelps.AppPropertyEstimatedValueBtl
            : referenceDataContextualHelps.AppPropertyEstimatedValueResidential
        "
        (valueChange)="onDprRelatedFieldValueChanged()"
      >
      </boi-form-numeric-input>

      <ng-container *ngIf="isAmendButtonAvailable">
        <button
          (click)="onAmendClick()"
          [innerHtml]="referenceDataLabels.ProductPickerAmend | localizeLabel"
          class="vo-secondary-button-1 full-width-md-button"
        ></button>
      </ng-container>
    </div>
  </ng-container>

  <div class="d-flex align-items-center flex-column flex-md-row">
    <!--8 & 8.6-->
    <boi-form-numeric-input
      [labelName]="
        mortgageApplication.IsFactFind
          ? referenceDataLabels.ProposedBorrowingAmount
          : referenceDataLabels.AmountToBorrowId
      "
      [isCurrency]="true"
      [value]="mortgageApplication.LoanAmountCache"
      (valueChange)="setLoanAmount($event)"
      [propertyNames]="['LoanAmount']"
      [isFieldDisabled]="
        mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly || isAmendButtonAvailable
      "
      [fieldMaxLength]="8"
      [tooltipName]="referenceDataLabels.AmountToBorrowToolTip"
      [contextualHelpName]="
        mortgageApplication.isBuyToLet
          ? referenceDataContextualHelps.AppLoanAmmountBtl
          : mortgageApplication.isAdvisedCase
          ? referenceDataContextualHelps.AdvisedAppLoanAmmountResidential
          : referenceDataContextualHelps.AppLoanAmmountResidential
      "
      (blurChange)="onMortgagePayOffAmountBlurChange()"
    >
    </boi-form-numeric-input>

    <ng-container *ngIf="isAmendButtonAvailable">
      <button
        (click)="onAmendClick()"
        [innerHtml]="referenceDataLabels.ProductPickerAmend | localizeLabel"
        class="vo-secondary-button-1 full-width-md-button"
      ></button>
    </ng-container>
  </div>

  <ng-container *ngIf="mortgageApplication.isRemortgage">
    <!--8.1 & 8.2-->
    <boi-form-numeric-input
      [labelName]="
        mortgageApplication.isBuyToLet
          ? referenceDataLabels.MortgagePayOffAmountBTL
          : referenceDataLabels.MortgagePayOffAmountResidential
      "
      [isCurrency]="true"
      [(value)]="mortgageApplication.MortgagePayOffAmount"
      [fieldMaxLength]="8"
      [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly"
      (valueChange)="updateMortgagePayOffDependencies()"
      [propertyNames]="['MortgagePayOffAmount']"
      [forceRequired]="true"
      (blurChange)="onMortgagePayOffAmountBlurChange()"
    >
    </boi-form-numeric-input>
  </ng-container>

  <!--8.3-->
  <ng-container *ngIf="areRemainderFundingDetailsVisible()">
    <boi-form-textarea
      [labelName]="referenceDataLabels.MortgageRemainderFundingDetails"
      [propertyNames]="['MortgageRemainderFundingDetails']"
      [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
      [(value)]="mortgageApplication.MortgageRemainderFundingDetails"
      [fieldMaxLength]="1500"
    ></boi-form-textarea>
  </ng-container>

  <ng-container *ngIf="areAdditionalBorrowingsVisible">
    <boi-validation-error [propertyNames]="['AdditionalBorrowings']"></boi-validation-error>
    <p
      [innerHtml]="referenceDataLabels.AdditionalBorrowingFor | localizeLabel"
      class="form-element subtitle-section my-15"
    ></p>

    <ng-container *ngIf="mortgageApplication.isBuyToLet">
      <boi-additional-borrowings-btl></boi-additional-borrowings-btl>
    </ng-container>

    <ng-container *ngIf="mortgageApplication.isResidential">
      <boi-additional-borrowings-residential></boi-additional-borrowings-residential>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!mortgageApplication.IsFactFind && !isDirectContext">
    <boi-form-application-product-selection
      [mortgageApplication]="mortgageApplication"
      (productChange)="onProductChange()"
      [isDisabled]="mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly"
    >
    </boi-form-application-product-selection>
  </ng-container>

  <ng-container *ngIf="applicationProducts[0]?.CaseProduct">
    <ng-container *ngIf="!mortgageApplication.IsFactFind">
      <!--4.1-->
      <ng-container *ngIf="mortgageApplication.isInterestAnyOtherPropertyCodeVisible && isLoanGroupTypeHelpToBuy()">
        <boi-form-radio-button
          [labelName]="referenceDataLabels.InterestAnyOtherProperty"
          [propertyNames]="['InterestAnyOtherPropertyCode']"
          [optionList]="referenceDataOptionLists.AnswerType"
          [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
          [(value)]="mortgageApplication.InterestAnyOtherPropertyCode"
          (valueChange)="changeProceedStatementVisible()"
        >
        </boi-form-radio-button>

        <ng-container *ngIf="isProceedStatementVisible">
          <boi-form-information-box
            [decoration]="'exclamation-mark'"
            [message]="referenceDataLabels.UnableProceedStatement"
            [includeOkButton]="true"
          >
          </boi-form-information-box>
        </ng-container>
      </ng-container>

      <div class="d-flex align-items-center align-items-md-start flex-column flex-md-row">
        <!--9 & 10-->
        <boi-form-term-input
          [labelName]="referenceDataLabels.BorrowingTermId"
          [tooltipName]="referenceDataLabels.BorrowingTermToolTip"
          [contextualHelpName]="
            mortgageApplication.isBuyToLet
              ? 'AppBorrowingTermBtl'
              : mortgageApplication.isAdvisedCase
              ? 'AdvisedAppBorrowingTermResidential'
              : 'AppBorrowingTermResidential'
          "
          [(years)]="applicationProducts[0].CaseProduct.LoanTermYears"
          [(months)]="applicationProducts[0].CaseProduct.LoanTermMonths"
          (yearsChange)="
            partAndPartProductService.isProductPartRepaymentPartInterest &&
              (applicationProducts[1].CaseProduct.LoanTermYears = $event)
          "
          (monthsChange)="
            partAndPartProductService.isProductPartRepaymentPartInterest &&
              (applicationProducts[1].CaseProduct.LoanTermMonths = $event)
          "
          [isFieldDisabled]="
            mortgageApplication.IsApplicationReadOnly ||
            mortgageApplication.IsFactFindReadOnly ||
            isAmendButtonAvailable
          "
          [propertyNames]="[
            'ApplicationProduct_0.LoanTerm',
            'ApplicationProduct_0.CaseProduct.LoanTermYears',
            'ApplicationProduct_0.CaseProduct.LoanTermMonths',
            'LoanTerm'
          ]"
          [tooltipName]="referenceDataLabels.BorrowingTermToolTip"
        >
        </boi-form-term-input>

        <ng-container *ngIf="isAmendButtonAvailable">
          <button
            (click)="onAmendClick()"
            [innerHtml]="referenceDataLabels.ProductPickerAmend | localizeLabel"
            class="vo-secondary-button-1 full-width-md-button align-self-center"
          ></button>
        </ng-container>
      </div>

      <!--11-->
      <boi-form-option-list
        [optionList]="repaymentTypeOptionList"
        [labelName]="referenceDataLabels.RepaymentTypeId"
        [propertyNames]="['ApplicationProduct_0.CaseProduct.RepaymentTypeCode']"
        [isFieldDisabled]="
          mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly || isAmendButtonAvailable
        "
        [value]="mortgageApplication.RepaymentTypeCodeCache"
        (valueChange)="setRepaymentType($event)"
        [contextualHelpName]="'KfiRepaymentType'"
      ></boi-form-option-list>
    </ng-container>

    <ng-container *ngIf="mortgageApplication.IsFactFind && mortgageApplication.isResidential">
      <!--9.1 & 10.1-->
      <boi-form-term-input
        [labelName]="referenceDataLabels.ProposedTermId"
        [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly"
        [contextualHelpName]="'AdvisedAppBorrowingTermResidential'"
        [(years)]="applicationProducts[0].CaseProduct.LoanTermYears"
        [(months)]="applicationProducts[0].CaseProduct.LoanTermMonths"
        (yearsChange)="
          partAndPartProductService.isProductPartRepaymentPartInterest &&
            (applicationProducts[1].CaseProduct.LoanTermYears = $event)
        "
        (monthsChange)="
          partAndPartProductService.isProductPartRepaymentPartInterest &&
            (applicationProducts[1].CaseProduct.LoanTermMonths = $event)
        "
        [propertyNames]="[
          'ApplicationProduct_0.CaseProduct.LoanTermYears',
          'ApplicationProduct_0.CaseProduct.LoanTermMonths',
          'LoanTerm'
        ]"
      >
      </boi-form-term-input>
      <!--12a1-->
      <boi-form-option-list
        [optionList]="referenceDataOptionLists.RepaymentTypeFF"
        [labelName]="referenceDataLabels.RepaymentTypeFFId"
        [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly"
        [propertyNames]="['ApplicationProduct_0.CaseProduct.RepaymentTypeCode']"
        [value]="mortgageApplication.RepaymentTypeCodeCache"
        (valueChange)="setRepaymentType($event)"
        [contextualHelpName]="'KfiRepaymentType'"
      ></boi-form-option-list>
    </ng-container>

    <ng-container *ngIf="partAndPartProductService.isProductPartRepaymentPartInterest">
      <boi-part-and-part-control
        [interestOnlyPart]="applicationProducts[0].CaseProduct.LoanAmount"
        (interestOnlyPartChange)="setInterestOnlyPart($event)"
        [repaymentPart]="applicationProducts[1]?.CaseProduct?.LoanAmount"
        [totalLoan]="mortgageApplication.LoanAmountCache"
        [isReadOnly]="
          mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly || isAmendButtonAvailable
        "
      >
      </boi-part-and-part-control>

      <!--19-->
      <boi-product-repayment-methods
        class="application-form-input"
        [isFieldDisabled]="
          mortgageApplication.IsApplicationReadOnly ||
          (mortgageApplication.IsFactFind && mortgageApplication.IsFactFindReadOnly)
        "
        [isMortgageApplicationFactFind]="mortgageApplication.IsFactFind"
        [isPartAndPart]="partAndPartProductService.isProductPartRepaymentPartInterest"
        [isMortgageApplicationBtl]="mortgageApplication.isBuyToLet"
        [(data)]="applicationProducts[0].ApplicationProductRepaymentMethods"
      >
      </boi-product-repayment-methods>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="partAndPartProductService.isProductInterestOnly">
    <!--23-->
    <boi-product-repayment-methods
      class="application-form-input"
      [isFieldDisabled]="
        mortgageApplication.IsApplicationReadOnly ||
        (mortgageApplication.IsFactFind && mortgageApplication.IsFactFindReadOnly)
      "
      [isMortgageApplicationFactFind]="mortgageApplication.IsFactFind"
      [isPartAndPart]="partAndPartProductService.isProductPartRepaymentPartInterest"
      [isMortgageApplicationBtl]="mortgageApplication.isBuyToLet"
      [(data)]="applicationProducts[0].ApplicationProductRepaymentMethods"
    >
    </boi-product-repayment-methods>
  </ng-container>

  <ng-container
    *ngIf="
      partAndPartProductService.isProductPartRepaymentPartInterest || partAndPartProductService.isProductInterestOnly
    "
  >
    <!--23.1-->
    <ng-container *ngIf="!mortgageApplication.IsFactFind">
      <boi-form-radio-button
        [optionList]="referenceDataOptionLists.AnswerType"
        [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.AreRepaymentAssetsInSterlingCode"
        [propertyNames]="['ApplicationProduct_0.AreRepaymentAssetsInSterlingCode']"
        [(value)]="applicationProducts[0].AreRepaymentAssetsInSterlingCode"
      ></boi-form-radio-button>
    </ng-container>

    <ng-container *ngIf="mortgageApplication.IsFactFind">
      <!--23.2-->
      <boi-form-numeric-input
        [labelName]="referenceDataLabels.RepaymentMonthlyCost"
        [isCurrency]="true"
        [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly"
        [(value)]="applicationProducts[0].RepaymentMonthlyCost"
        [propertyNames]="['ApplicationProduct_0.RepaymentMonthlyCost']"
        [fieldMaxLength]="4"
      ></boi-form-numeric-input>

      <!--23.3-->
      <boi-form-date
        [labelName]="referenceDataLabels.RepaymentMaturityDate"
        [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly"
        [(value)]="applicationProducts[0].RepaymentMaturityDate"
        [propertyNames]="['ApplicationProduct_0.RepaymentMaturityDate']"
      ></boi-form-date>

      <!--23.4-->
      <boi-form-numeric-input
        [labelName]="referenceDataLabels.RepaymentProjectedValue"
        [isCurrency]="true"
        [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly"
        [(value)]="applicationProducts[0].RepaymentProjectedValue"
        [propertyNames]="['ApplicationProduct_0.RepaymentProjectedValue']"
        [fieldMaxLength]="8"
      >
      </boi-form-numeric-input>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="areDepositSourcesVisible()">
    <!--166-->
    <boi-form-deposit-source-type [(mortgageApplication)]="mortgageApplication"></boi-form-deposit-source-type>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.IsAip">
    <!--155.1-->
    <boi-form-numeric-input
      [isCurrency]="true"
      [labelName]="referenceDataLabels.ContinuingMonthlyPaymentsOnOutgoings"
      [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
      [(value)]="mortgageApplication.ContinuingMonthlyPayments"
      [propertyNames]="['ContinuingMonthlyPayments']"
      [fieldMaxLength]="5"
    >
    </boi-form-numeric-input>

    <!--155.2-->
    <ng-container *ngIf="isResidentialLoanGroupTypeFirstStart()">
      <boi-form-numeric-input
        [isCurrency]="true"
        [labelName]="referenceDataLabels.MonthlySponsorOutgoings"
        [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
        [(value)]="mortgageApplication.MonthlySponsorOutgoings"
        [propertyNames]="['MonthlySponsorOutgoings']"
        [fieldMaxLength]="5"
      >
      </boi-form-numeric-input>
    </ng-container>

    <!--42-->
    <boi-form-numeric-input
      [labelName]="
        mortgageApplication.isBuyToLet
          ? referenceDataLabels.NumberOfDependentsBTL
          : referenceDataLabels.NumberOfDependentsId
      "
      [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
      [(value)]="mortgageApplication.Applicants[0].NumberOfDependants"
      [propertyNames]="['Applicant_0.NumberOfDependants']"
      [contextualHelpName]="
        mortgageApplication.isBuyToLet ? referenceDataLabels.NumberOfDependentsBTL : 'AppNoOfDependants'
      "
      (valueChange)="mortgageApplication.initializeDependants()"
      [fieldMaxLength]="2"
    ></boi-form-numeric-input>

    <!--43-->
    <ng-container *ngIf="mortgageApplication.Applicants[0].NumberOfDependants > 0">
      <ng-container
        *ngFor="let dependant of mortgageApplication.Applicants[0].ApplicantDependants; index as dependantIndex"
      >
        <boi-form-numeric-input
          [labelName]="referenceDataLabels.AgeOfFinancialDependant"
          [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
          [labelIndex]="dependantIndex + 1"
          [controlId]="referenceDataLabels.AgeOfFinancialDependant + dependantIndex"
          [propertyNames]="['Applicant_0.ApplicantDependant_' + dependantIndex + '.' + 'Age']"
          [(value)]="dependant.Age"
        >
        </boi-form-numeric-input>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="mortgageApplication.isBuyToLet && mortgageApplication.IsAip">
      <boi-form-numeric-input
        [labelName]="referenceDataLabels.HowManyBtlWithUs"
        [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
        [(value)]="mortgageApplication.HowManyBtlWithUs"
        [propertyNames]="['HowManyBtlWithUs']"
        [contextualHelpName]="'AppOtherBtlWithUsDetails'"
        [fieldMaxLength]="3"
      >
      </boi-form-numeric-input>

      <ng-container *ngIf="areBtlAdditionalFieldsVisible()">
        <boi-form-numeric-input
          [isCurrency]="true"
          [labelName]="referenceDataLabels.TotalLoanAmounts"
          [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
          [(value)]="mortgageApplication.BtlWithUsTotalOutstandingLoanAmount"
          [propertyNames]="['BtlWithUsTotalOutstandingLoanAmount']"
          [fieldMaxLength]="8"
          [fieldMaxValue]="99999999"
        >
        </boi-form-numeric-input>

        <boi-form-textarea
          [labelName]="referenceDataLabels.OtherBtlWithUsDetails"
          [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
          [propertyNames]="['OtherBtlWithUsDetails']"
          [(value)]="mortgageApplication.OtherBtlWithUsDetails"
          [fieldMaxLength]="1500"
        ></boi-form-textarea>
      </ng-container>

      <boi-form-numeric-input
        [labelName]="referenceDataLabels.HowManyBtlInTotal"
        [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
        [(value)]="mortgageApplication.HowManyBtlInTotal"
        [propertyNames]="['HowManyBtlInTotal']"
        [contextualHelpName]="'AppHowManyBtlInTotal'"
        [fieldMaxLength]="3"
      >
      </boi-form-numeric-input>

      <ng-container *ngIf="isLoanGroupTypeBtlAffordability()">
        <ng-container *ngIf="isTotalBalanceOutstandingBtlVisible()">
          <boi-form-numeric-input
            [isCurrency]="true"
            [labelName]="referenceDataLabels.TotalBalanceOutstandingBtlMortgage"
            [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
            [(value)]="mortgageApplication.TotalBalanceOutstandingBtlMortgage"
            [propertyNames]="['TotalBalanceOutstandingBtlMortgage']"
            [fieldMaxLength]="8"
          ></boi-form-numeric-input>
        </ng-container>

        <ng-container *ngIf="isTotalBalanceOutstandingBtlVisible() || areBtlAdditionalFieldsVisible()">
          <boi-form-numeric-input
            [isCurrency]="true"
            [labelName]="referenceDataLabels.TotalMonthlyRentalIncomeBtl"
            [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
            [(value)]="mortgageApplication.TotalMonthlyRentalIncomeBtl"
            [propertyNames]="['TotalMonthlyRentalIncomeBtl']"
            [fieldMaxLength]="8"
          >
          </boi-form-numeric-input>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.IsFullApp">
    <div
      class="direct-debit vo-panel-white p-15 my-15"
      [innerHtml]="referenceDataLabels.DirectDebitFormInformation | localizeLabel"
    ></div>
    <!--251-->
    <boi-form-text-input
      [labelName]="referenceDataLabels.BankBuildingSocietyName"
      [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
      [propertyNames]="['BankBuildingSocietyName']"
      [fieldMaxLength]="40"
      [(value)]="mortgageApplication.BankBuildingSocietyName"
    >
    </boi-form-text-input>
    <!--252-->
    <boi-form-text-input
      [labelName]="referenceDataLabels.AccountHolderName"
      [propertyNames]="['AccountHolderName']"
      [fieldMaxLength]="300"
      [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
      [(value)]="mortgageApplication.AccountHolderName"
    >
    </boi-form-text-input>
    <!--253, 254 & 255-->
    <boi-sort-code-input [(mortgageApplication)]="mortgageApplication"></boi-sort-code-input>
    <!--256-->
    <boi-form-text-input
      [labelName]="referenceDataLabels.AccountNumber"
      [(value)]="mortgageApplication.AccountNumber"
      [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
      [propertyNames]="['AccountNumber']"
      [fieldMaxLength]="8"
      [digitsOnly]="true"
    ></boi-form-text-input>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.IsFullApp">
    <!--251.1-->
    <boi-form-radio-button
      [labelName]="referenceDataLabels.MoreThanOneSignatoryForDirectDebit"
      [propertyNames]="['MoreThanOneSignatoryForDirectDebitCode']"
      [optionList]="referenceDataOptionLists.AnswerType"
      [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
      [(value)]="mortgageApplication.MoreThanOneSignatoryForDirectDebitCode"
      (valueChange)="changeMoreThanOneSignatoryForDirectDebitCode()"
    >
    </boi-form-radio-button>

    <ng-container
      *ngIf="mortgageApplication.MoreThanOneSignatoryForDirectDebitCode === referenceDataOptionLists.AnswerTypeYes"
    >
      <boi-form-information-box
        [message]="referenceDataLabels.MultipleDirectDebitSignaturesWarning"
        [decoration]="'exclamation-mark'"
      ></boi-form-information-box>
    </ng-container>

    <!--251.2-->
    <ng-container
      *ngIf="mortgageApplication.MoreThanOneSignatoryForDirectDebitCode === referenceDataOptionLists.AnswerTypeNo"
    >
      <boi-form-option-list
        [availableOptions]="mortgageApplication.Applicants"
        [textField]="'FullName'"
        [valueField]="'ApplicantTransactOrder'"
        [labelName]="referenceDataLabels.ApplicantAccountHolder"
        [isFieldDisabled]="mortgageApplication.IsApplicationReadOnly"
        [propertyNames]="['Applicant_0.IsAccountHolder']"
        [(value)]="applicantAccountHolderIdentifier"
        (valueChange)="changeApplicantAccountHolder()"
      >
      </boi-form-option-list>
    </ng-container>
  </ng-container>
</ng-container>
